import * as React from "react";
import { SVGProps, memo } from "react";

const SvgErrorToast = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.813-8.34 2.018 2.018a.568.568 0 0 1-.003.807.572.572 0 0 1-.81 0L10 10.467l-2.018 2.018a.574.574 0 0 1-.81-.81L9.19 9.657 7.172 7.639a.572.572 0 1 1 .813-.808l2.018 2.019L12.02 6.83a.574.574 0 0 1 .81.81L10.813 9.66Z"
      fill="#fff"
    />
  </svg>
);

const Memo = memo(SvgErrorToast);

export default Memo;
